// 追梦中国相关页面
export var ROUTE_NAME = {
  INDEX: 'INDEX',
  HOME: 'HOME',
  INVITATION: 'INVITATION'
};
var STATIC_HOST = 'https://static.run100.runorout.cn';
export var STATIC_HOST_TRIANGLE = STATIC_HOST + "/static/img/triangle";
export function getTriangleImg(name) {
  return STATIC_HOST_TRIANGLE + "/" + name;
}